import { FormControl, FormLabel, Input, Switch } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";

import FixedBar from "components/ui/FixedBar";
import SubmitButton from "components/ui/SubmitButton";
import { useSuccessDialogContext } from "components/ui/SuccessDialog/SuccessDialogContext";
import { useMessages } from "hooks/useMessages";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Inputs, useSavePL } from "../hooks/useSavePL";

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
});

type FormProps = {
  pl?: any;
};

export default function PLForm({ pl }: FormProps) {
  const defaultValues: Inputs = {
    name: pl?.name,
    active: pl?.active,
  };

  const navigate = useNavigate();
  const { openSuccessDialog } = useSuccessDialogContext();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(validationSchema) as Resolver<Inputs>,
    defaultValues,
  });

  const { onError } = useMessages();

  const isActive = watch("active");

  const { onSavePL, isPending } = useSavePL({
    plId: pl?.id,
    onSuccess: () => {
      reset();
      navigate("/pls");
      if (!pl?.id) {
        openSuccessDialog({
          title: "Nova proposição legislativa cadastrada!",
          description: "",
          actionButtonText: "Criar mais uma proposição legislativa",
          actionButton: "/pl/novo",
          closeButtonText: "Tudo certo",
        });
      }
    },
    onError: (error) => onError(error?.response?.data?.message),
  });

  const onSubmit: SubmitHandler<Inputs> = (data) => onSavePL(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={!!errors.name} isRequired>
        <FormLabel>Nome</FormLabel>
        <Input {...register("name")} autoFocus />
      </FormControl>

      {pl && (
        <FormControl isInvalid={!!errors.active}>
          <FormLabel>Status</FormLabel>
          <Switch {...register("active")}>
            {isActive ? "Ativo" : "Inativo"}
          </Switch>
        </FormControl>
      )}

      <FixedBar>
        <SubmitButton isDisabled={isPending || !isValid} isLoading={isPending}>
          {!pl ? "Cadastrar" : "Atualizar"}
        </SubmitButton>
      </FixedBar>
    </form>
  );
}
